export default "__VITE_ASSET__Bktgg6p9__"